import { render } from "./TabbyDue.vue?vue&type=template&id=2d54f161&scoped=true"
import script from "./TabbyDue.vue?vue&type=script&lang=js"
export * from "./TabbyDue.vue?vue&type=script&lang=js"

import "./TabbyDue.vue?vue&type=style&index=0&id=2d54f161&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2d54f161"

export default script